import { Box, Text } from '@chakra-ui/react'

import { OurServices } from '@/components/Landing'

import * as DATA from '@/features/Services/constants'

interface Props {
  serviceName: Exclude<keyof typeof DATA, 'default'>
}

function PriceSection({ serviceName }: Props): React.ReactElement {
  const pageData = serviceName ? DATA[serviceName] : DATA['default'][0]

  return (
    <Box
      sx={{
        overflowY: 'visible',
        bg: 'customGray.100',
        py: {
          base: 16,
          'lg+': 20,
        },
        my: {
          base: 10,
          'lg+': 20,
        },
      }}
    >
      <Text
        as="h1"
        sx={{
          textAlign: 'center',
          fontWeight: 'bold',
          fontSize: {
            base: '28px',
            md: '40px',
          },
          '& + *': {
            py: {
              base: '16px !important',
              md: '32px !important',
            },
          },
        }}
      >
        ราคา
      </Text>
      <OurServices
        hideHeader
        hideDecor
        primaryColor={pageData.PRIMARY_COLOR}
        initialService={serviceName}
      />
    </Box>
  )
}

export default PriceSection
